export function linkHome(): string {
    return "/";
}
